import { QueryClient } from "@tanstack/react-query";
import { TRPCClientError } from "@trpc/client";
import { UNAUTHED_ERR_MSG } from "@shared/const";

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 2 * 60 * 1000, // 2 minutes — reduces refetches on tab switches
        gcTime: 30 * 60 * 1000, // 30 minutes — cached data survives tab navigation
        // Live conversational data is refreshed by the app's resume listeners;
        // everything else stays focus-quiet to protect battery on Capacitor.
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        // Retry transient failures (network blips, and the brief window while a
        // new deploy is starting) with backoff — so an app update doesn't bounce
        // a still-valid session. Never retry a genuine "you're logged out": that
        // goes straight to the app's unauthorized→login handler.
        retry: (failureCount, error) => {
          if (
            error instanceof TRPCClientError &&
            error.message === UNAUTHED_ERR_MSG
          )
            return false;
          return failureCount < 4;
        },
        retryDelay: attempt => Math.min(1000 * 2 ** attempt, 15000),
        networkMode: "offlineFirst", // Show cached data even when offline
      },
      mutations: {
        // A failed response does not prove the write failed. Retrying a payment,
        // message or workout submission can duplicate a committed operation.
        retry: false,
        networkMode: "offlineFirst",
      },
    },
  });
}
